<template>
	<Slides :slides="slides" class="center-content" />
</template>

<script>
import { $src } from '@/lib/utils'

import Slides from './Slides.vue'

export default {
	name: 'SlidesAwards',
	components: {
		Slides,
	},
	data: () => ({
		slides: [
				{
					body: `<img src="${$src('/assets/slides/awards/1.png')}" alt="Award 1" />`
				},
				{
					body: `<img src="${$src('/assets/slides/awards/2.png')}" alt="Award 2" />`
				},
				{
					body: `<img src="${$src('/assets/slides/awards/3.png')}" alt="Award 3" />`
				},
				{
					body: `<img src="${$src('/assets/slides/awards/4.png')}" alt="Award 4" />`
				},
				{
					body: `<img src="${$src('/assets/slides/awards/5.png')}" alt="Award 5" />`
				},
			]
	})
}
</script>

<style scoped lang="scss">
</style>
